module.exports = " <div class=fail> <img src=//static.daojia.com/fe/jz/daojiaapp/hongbao/image/fail.3530329e.png alt=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Fail.vue
// module id = 145
// module chunks = 0